export default "__VITE_ASSET__wxJgroqB__"